import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import { $textPrimary, $textTertiary } from '../../../../styles/colors/semantics'
import Spacer from '../../../Spacer'
import CtaV2 from '../../../CtaV2'

function TeamVrsHero({ image, title, subtitle, textA, textB, textC, ctaV2 }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        <div className={styles.textWrapper}>
          <div className={styles.titleSection}>
            {/* Single-<h1> rule (Audit A #1): promote the hero title to the page's
                one visible <h1>. `.h1-contents` adds no box (byte-identical). */}
            <h1 className="h1-contents"><SimpleBlockContent blocks={title}/></h1>
            <div className={styles.subtitle}><SimpleBlockContent blocks={subtitle}/></div>
          </div>
          <div className={styles.textSection}>
            <SimpleBlockContent blocks={textA.text} highlight={textA.highlight} highlightSx={`color: ${$textTertiary.dark};`}/>
            <Spacer size={8}/>
            <SimpleBlockContent blocks={textB.text} highlight={textB.highlight} highlightSx={`color: ${$textTertiary.dark};`}/>
          </div>
          <div className={styles.textCSection}>
            <SimpleBlockContent blocks={textC.text} highlight={textC.highlight} highlightSx={`color: ${$textPrimary.dark};`} highlightExactMatch/>
          </div>
          <CtaV2 {...ctaV2}/>
        </div>
        {/* task #67: styled bg fed the resolved descriptor url */}
        <div
          className={styles.image}
          style={{ background: `linear-gradient(225deg, rgba(0, 0, 0, 0.00) 50%, #000 100%), url(${image?.src}) lightgray 50% / cover no-repeat` }}
        />
      </div>
    </div>
  )
}

export default TeamVrsHero
